import React from "react";
import { NavigationLinkType } from "../../../../../types";
import QuickLink from "./QuickLink";
import { QuickLinksContainer } from "./QuickLinkStyles";

type QuickLinksProps = {
  links?: NavigationLinkType[];
};

const QuickLinks: React.FC<QuickLinksProps> = ({ links = [] }) => {
  return (
    <QuickLinksContainer>
      {links.map((ql) => (
        <QuickLink {...ql} key={ql.name} />
      ))}
    </QuickLinksContainer>
  );
};

export default QuickLinks;
